import { FC } from 'react';

type Props = {
  message: string;
};
const SuccessNotification: FC<Props> = ({ message }) => {
  return (
    <div className='text-center'>
      <i className='bi bi-check-all fs-1 fw-bolder text-success'></i>
      <p className='fs-5 mt-2 mb-2 fw-bolder text-muted'>{message}</p>
    </div>
  );
};

export default SuccessNotification;
